import {
  Activity,
  Bot,
  BrainCircuit,
  FileText,
  Gauge,
  HeartPulse,
  Home,
  Menu,
  RadioTower,
  Settings,
  X,
} from 'lucide-react'
import { useState, type ReactNode } from 'react'
import type { PageKey } from '../types'

const nav: Array<{ key: PageKey; label: string; icon: typeof Home }> = [
  { key: 'home', label: 'Home', icon: Home },
  { key: 'trends', label: 'Trends', icon: RadioTower },
  { key: 'hdm', label: 'HDM memory', icon: BrainCircuit },
  { key: 'sources', label: 'Sources', icon: Gauge },
  { key: 'reports', label: 'Reports', icon: FileText },
  { key: 'settings', label: 'Settings', icon: Settings },
  { key: 'health', label: 'Health & debug', icon: HeartPulse },
  { key: 'setup', label: 'Guided setup', icon: Bot },
]

export function Layout({ page, setPage, cloud, viewerOnly = false, children }: { page: PageKey; setPage: (page: PageKey) => void; cloud: boolean; viewerOnly?: boolean; children: ReactNode }) {
  const [open, setOpen] = useState(false)
  const choose = (key: PageKey) => { setPage(key); setOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }) }
  const visibleNav = viewerOnly ? nav.filter(({ key }) => key === 'reports') : nav
  return (
    <div className="app-shell">
      <button className="mobile-menu" onClick={() => setOpen(!open)} aria-label="Open navigation">{open ? <X /> : <Menu />}</button>
      <aside className={`sidebar ${open ? 'sidebar-open' : ''}`}>
        <div className="brand">
          <div className="brand-mark"><Activity /></div>
          <div><strong>hdm radar</strong><span>trend intelligence</span></div>
        </div>
        <nav>
          {visibleNav.map(({ key, label, icon: Icon }) => (
            <button key={key} className={page === key ? 'active' : ''} onClick={() => choose(key)}><Icon /><span>{label}</span></button>
          ))}
        </nav>
        <div className="sidebar-footer">
          <span className={`connection-dot ${cloud ? 'connected' : ''}`} />
          <div><strong>{cloud ? 'Cloud connected' : 'Safe demo mode'}</strong><small>{viewerOnly ? 'Report viewer' : cloud ? 'Live memory' : 'No external calls'}</small></div>
        </div>
      </aside>
      <main className="main-content">{children}</main>
    </div>
  )
}

export function PageHeader({ eyebrow, title, body, actions }: { eyebrow?: string; title: string; body: string; actions?: ReactNode }) {
  return (
    <header className="page-header">
      <div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h1>{title}</h1><p>{body}</p></div>
      {actions && <div className="page-actions">{actions}</div>}
    </header>
  )
}
